
@if (isTypeOk == undefined && isIssueChangeAction == undefined) {

    <div class="div-message-box animated fadeIn fast" >
        <div class="message-box-container animated fadeIn fast">
            <div class="message-box-middle">
                <span class="msg-title">
                    <i class="fa fa-sign-out txt-color-orangeDark"></i>{{header}} </span>
                <p class="p-text">{{message}}</p>
    
                <div class="message-box-button-section">
                    <button class="btn btn-default btn-xs" id="switch-no" (click)="cancel()"> No</button>
                    <button class="btn btn-danger btn-xs" id="switch-yes" (click)="confirm()"> Yes</button>
                </div>
            </div>
        </div>
    </div>

}
@if (isTypeOk!=null) {
<div>
    <div class="div-message-box animated fadeIn fast" #confirmOk>
        <div class="message-box-container animated fadeIn fast">
            <div class="message-box-middle">
                <span class="msg-title">
                    <i class="fa fa-sign-out txt-color-orangeDark"></i>{{header}} </span>
                <p class="p-text">{{message}}</p>
                <div class="message-box-button-section">
                    <button class="btn btn-success btn-xs" id="switch-ok" (click)="cancel()"> Ok</button>
                </div>
            </div>
        </div>
    </div>
</div>
}
@if (isIssueChangeAction!=null) {
<div>
    <div class="div-message-box animated fadeIn fast" >
        <div class="message-box-container animated fadeIn fast">
            <div class="message-box-middle">
                <span class="msg-title">
                    <i class="fa fa-sign-out txt-color-orangeDark"></i>{{header}} </span>
                <p class="p-text">{{message}}</p>
                <div class="message-box-button-section">
                    <button class="btn btn-default btn-xs" id="switch-no" (click)="cancel()"> No</button>
                    <button class="btn btn-danger btn-xs" id="switch-yes" (click)="saveWithIssueId(true)"> Save with {{globalIssue}}</button>
                    <button class="btn btn-danger btn-xs" id="switch-yes" (click)="saveWithIssueId(false)"> Save with {{rowIssue}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
}

